var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 117,
    viewBox: "0 0 106 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2068 86.3508L24.7029 74.4329L12.0078 96.9732L46.2068 116.663L105.537 14.0666L92.3235 6.55322L46.2068 86.3508Z",
    fill: "#2FBE9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3219 6.55295L81.1813 0.334961L35.0312 80.1579L46.2315 86.4125L92.3219 6.55295Z",
    fill: "#47D9B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5467 68.0078L0.460938 90.5774L12.1197 97.0545L24.9463 74.4849L13.5467 68.0078Z",
    fill: "#47D9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.ad22ae3d3886911cc47d44e9f99588b5.svg";
export { ForwardRef as ReactComponent };